/**
 * Created by ostapenko.r on 9/19/2014.
 */
angular.module('flipto.components.common.listEditor', ['flipto.core.lodash']);